import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse } from './base.blog.service';

export const useBlogsQuery = (params: string = '') =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.GET_BLOGS}?${params}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['blog-list', params],
		refetchOnWindowFocus: false,
	});

export const useBlogCategoriesQuery = () =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.GET_BLOG_CATEGORIES}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['blog-categories-list'],
		refetchOnWindowFocus: false,
	});

export const useBlogDetailsQuery = (id: string = '') =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.GET_BLOGS}/${id}?populate=*`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['blog-details', id],
		refetchOnWindowFocus: false,
		enabled: !!id,
	});
